import styled from 'styled-components'
import globals from '../globals'
import Button from '../button/index'

export const HeaderWrapper = styled.header`
  position: fixed;
  left:50%;
  top:0;
  width:100%;
  display: flex;
  z-index: 1000;
  transform: translateX(-50%);
  max-width: ${globals.maxWidth};
  padding: 20px ${globals.paddingSides.normal};

  @media ${globals.mediaqueries.extraSmall}{
    padding: 15px ${globals.paddingSides.small}
  }

  @media ${globals.mediaqueries.small}{
    padding: 15px ${globals.paddingSides.small}
  }

  &:before {
    content:"";
    width: 100vw;
    height: 100%;
    display: block;
    position: absolute;
    left: 50%;
    top:0;
    z-index:-1;
    /* background: rgba(20,181,196,0.87); */
    background: rgba(68,203,245,0.27);
    transition: opacity .2s, transform .2s;
    opacity: 1;
    transform: translate3d(-50%,0, 0);
  }
`

export const LogosWrapper = styled.ul`
  align-self: center;
  list-style:none;
  margin:0;
  padding:0;
  width:122px;
  display:block;

  & > li {
    position: relative;
    margin:0;
    padding:0;
    display:inline-block;
  }

  img {
    width:100%;
    height:auto;
    display: block;
  }
`

export const MenuWrapper = styled.nav`
  margin-right:0;
  margin-left:auto;
  align-self: center;
  position:relative;

  & > ul {
    margin:0;
    padding:0;
    list-style:none;

    @media ${globals.mediaqueries.small}{
      position:fixed;
      height:100vh;
      right:0;
      top:0;
      bottom:0;
      width:100%;
      text-align: center;
      background: ${globals.colors.darkblue};
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: all .2s;
      opacity: ${props => props.isMenuOpen ? 1 : 0};
      pointer-events: ${props => props.isMenuOpen ? 'auto' : 'none'};
      z-index:-1;
    }

    @media ${globals.mediaqueries.extraSmall}{
      position:fixed;
      height:100vh;
      right:0;
      top:0;
      bottom:0;
      width:100%;
      text-align: center;
      background: ${globals.colors.darkblue};
      display: flex;
      flex-direction: column;
      justify-content: center;
      transition: all .2s;
      opacity: ${props => props.isMenuOpen ? 1 : 0};
      pointer-events: ${props => props.isMenuOpen ? 'auto' : 'none'};
      z-index:-1;
    }

    & > li {
      margin:0;
      padding:0;
      display: inline-block;
      line-height: ${globals.inputs.lineHeight.normal};

      @media ${globals.mediaqueries.small}{
        display:block;
      }

      @media ${globals.mediaqueries.extraSmall}{
        display:block;
      }

      &:first-child > a {
        padding-left:0;
      }

      & > a {
        display: inline-block;
        padding: 0 23px;
        line-height: ${globals.inputs.lineHeight.normal};
        transition: all .2s;
        border-radius:23px;

        @media ${globals.mediaqueries.medium}{
          padding:0 6px;
        }
        
        &:hover {
          color: ${props => props.withBackground || props.isMenuOpen ? globals.colors.lightblue : globals.colors.darkblue};
        }

        &:focus {
          outline:none;
          color: ${globals.colors.lightblue};
        }
      }

      & + li {
        margin-left:10px;
        margin-left:1vw;
      }
    }

    button {

      &:hover {
        box-shadow:inset 0 0 0 2px ${globals.colors.lightblue};
        color: ${props => props.withBackground ? globals.colors.lightblue : 'inherit'};
      }

      &:focus {
        color: ${globals.colors.lightblue};
      }
    }
  }

  .dot {

    a:before {
      content:"•";
      color: #003864;
      padding-right:6px;
    }
  }

  a {
    text-decoration: none;
    font-size: 15px;
    letter-spacing: 0px;
    line-height: 11px;
    color: #003864;
    font-weight: 500;
    font-family: "Roboto";

    @media ${globals.mediaqueries.small}{
      color: #FFFFFF;
    }

    @media ${globals.mediaqueries.extraSmall}{
      color: #FFFFFF;
    }
  }

  .menu-toggle {
    display:none;

    @media ${globals.mediaqueries.small}{
      display: inline-block;
    }

    @media ${globals.mediaqueries.extraSmall}{
      display: inline-block;
    }
  }
`

const buttonWidth = '32px'
export const HamburguerMenuButton = styled(Button)`
  overflow: hidden;
  display: inline-block;
  overflow: visible;
  cursor: pointer;
  transition-timing-function: linear;
  transition-duration: .15s;
  transition-property: opacity,filter;
  text-transform: none;
  color: inherit;
  border: 0;
  padding-left:12px;
  padding-right:12px;
  border-radius:50%;
  background-color: transparent;
  box-shadow: inset 0 0 0 2px #003864;

  &:focus {
    box-shadow: inset 0 0 0 2px #003864;
  }

  .hamburger-box {
    overflow: hidden;
    position: relative;
    display: inline-block;
    width: ${buttonWidth};
    height: 24px;
    transform: translateY(5px);

    .hamburger-inner {
      transition: background-color .125s ease-in .175s;
      top: 50%;
      position: absolute;
      width: ${buttonWidth};
      height: 4px;
      display: block;
      transition-timing-function: ease;
      transition-duration: .15s;
      transition-property: transform;
      border-radius: 4px;
      background-color: ${props => props.isActive ? 'transparent' : '#003864'};
      display: block;
      margin-top: -2px;

      &:after, &:before {
        content:"";
        position: absolute;
        width: ${buttonWidth};
        height: 4px;
        display: block;
        transition-timing-function: ease;
        transition-duration: .15s;
        transition-property: transform;
        border-radius: 4px;
        background-color: ${props => props.isActive ? '#FFF' : '#003864'};
      }

      &:before {
        top: ${props => props.isActive ? '-80px' : '-10px'};
        left: ${props => props.isActive ? '-80px' : '0'};
        transition: ${props => props.isActive ? 'left .125s ease-out,top .05s linear .125s,transform .125s cubic-bezier(.075,.82,.165,1) .175s' : 'transform .125s cubic-bezier(.6,.04,.98,.335),top .05s linear .125s,left .125s ease-in .175s'};
        transform: ${props => props.isActive ? 'translate3d(80px,80px,0) rotate(45deg)' : ''};
      }

      &:after {
        bottom: -10px;
        top: ${props => props.isActive ? '-80px' : '10px'};
        right: ${props => props.isActive ? '-80px' : '0'};
        transition: ${props => props.isActive ? 'right .125s ease-out,top .05s linear .125s,transform .125s cubic-bezier(.075,.82,.165,1) .175s' : 'transform .125s cubic-bezier(.6,.04,.98,.335),top .05s linear .125s,right .125s ease-in .175s'};
        transform: ${props => props.isActive ? 'translate3d(-80px,80px,0) rotate(-45deg)' : ''};
      }
    }
    
  }
`